import React, { Component } from 'react';
import Panel from './shared/Panel';
import Filter from './shared/Filter';
import DappAccountTransactions from './containers/DappAccountTransactions';
import Info from './shared/Info';

export default class DappAccountTransactionsPanel extends Component {
	state = {
		q: ''
	};

	onSubmitFilter = (value) => {
		this.setState({ q: value });
	};

	render() {
		const { q } = this.state;
		return (
			<Panel
				title={
					<React.Fragment>
						TRANSACTIONS <Info id="txns" />
					</React.Fragment>
				}
				description=""
				toolbar={
					<React.Fragment>
						<Filter onSubmitFilter={this.onSubmitFilter} />
						{/* <PeriodSelector /> */}
					</React.Fragment>
				}
			>
				<DappAccountTransactions filter={q} accountNumber={this.props.accountNumber} />
			</Panel>
		);
	}
}
